// Planificar una tarea: textos y fechas. Puro, sin React ni red.
const SEMANA = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
const NOMBRE = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
const LETRA = ["D", "L", "M", "X", "J", "V", "S"];

const aIso = d =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const deIso = iso => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ""));
  return m ? new Date(+m[1], +m[2] - 1, +m[3], 12) : null;
};

// "Mié 28" para una fecha ISO
export function etiquetaDia(iso) {
  const d = deIso(iso);
  return d ? `${SEMANA[d.getDay()][0].toUpperCase()}${SEMANA[d.getDay()].slice(1)} ${d.getDate()}` : "";
}

// Lo que dice el boton de la fila: «Planificar», «Hoy», «Mié 28» o «Esta semana».
export function textoPlan(plan, hoy = new Date()) {
  if (!plan || !plan.tipo) return "Planificar";
  if (plan.tipo === "semana") return "Esta semana";
  if (plan.tipo === "semana_siguiente") return "Semana que viene";
  if (plan.tipo === "hoy" || plan.dia === aIso(hoy)) return "Hoy";
  return etiquetaDia(plan.dia) || "Planificar";
}

// Los siete dias de la semana de `hoy`, de lunes a domingo.
// `semanas` = 0 la de hoy, 1 la que viene.
export function diasDeLaSemana(hoy = new Date(), semanas = 0) {
  const base = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 12);
  base.setDate(base.getDate() - ((base.getDay() + 6) % 7) + 7 * semanas);
  const hoyIso = aIso(hoy);
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(base); d.setDate(base.getDate() + i);
    const iso = aIso(d);
    return { iso, letra: LETRA[d.getDay()], numero: d.getDate(), nombre: `${NOMBRE[d.getDay()]} ${d.getDate()}`,
             pasado: iso < hoyIso, esHoy: iso === hoyIso };
  });
}

export const HORAS_AVISO = ["08:00", "09:00", "10:00", "12:00", "16:00"];
export const HORA_DEFECTO = "09:00";

// «Mié 28, 09:00» (o solo la fecha si no hay hora)
export const textoRecordatorio = r =>
  r ? `${etiquetaDia(r.dia)}${r.hora ? `, ${r.hora}` : ""}` : "";
